import { PublicService } from '@/services/public.services'

const state = {
  loading: false,
  dialogsyarat: false,
  dialog: false,
  overlay: false,
  sliders: []
}
const actions = {
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  setdialogsyarat ({ commit }, diag) {
    commit('setdialogsyarat', diag)
  },
  getSliders ({ commit }) {
    commit('setloading', true)
    PublicService.getSlider().then(value => {
      commit('setloading', false)
      commit('setsliders', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  }
}
const mutations = {
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setdialogsyarat (state, s) {
    state.dialogsyarat = s
  },
  setsliders (state, s) {
    state.sliders = []
    state.sliders = s.data
    state.loading = false
    state.overlay = false
  }
}

export const PublicStore = {
  namespaced: true,
  state,
  actions,
  mutations
}
